var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22,3a1.31,1.31,0,0,0-.06-.27l0-.1a1.06,1.06,0,0,0-.21-.31,1,1,0,0,0-.3-.2l-.1,0A.87.87,0,0,0,21,2h-.08a1.28,1.28,0,0,0-.32.06L2.69,8.33a1,1,0,0,0-.08,1.93l7.7,3.43,3.42,7.69a1.05,1.05,0,0,0,1,.62h0a1,1,0,0,0,.94-.7l2.06-5.88-2-.69-1.19,3.41-2.23-5L18.47,7l-2.08,5.92,2,.69L21.94,3.38a.86.86,0,0,0,0-.32S22,3,22,3ZM17,5.53l-6.12,6.12-5-2.22Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessage);
export default __webpack_public_path__ + "static/media/send-message.ca979594dfd806f21b670a7ec7e65b10.svg";
export { ForwardRef as ReactComponent };